var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Subject } from 'rxjs/Subject';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { UserService } from '../../../../services/user.service';
import { chartConfig } from '../../../../app.constants';
var InteractionRateByChannelComponent = /** @class */ (function () {
    function InteractionRateByChannelComponent(userService) {
        var _this = this;
        this.hasNoData = false;
        this._selectedColor = userService.chartColors[0];
        this._placeholderData = {
            columns: [
                {
                    channelName: 'Instagram',
                    interactionRate: 2.3,
                    heightPercentage: '23%',
                    maxWidthPercentage: '25%',
                    placeholderMode: true,
                    color: 'rgba(149,160,177, 0.1)'
                },
                {
                    channelName: 'Youtube',
                    interactionRate: 8.6,
                    heightPercentage: '86%',
                    maxWidthPercentage: '25%',
                    placeholderMode: true,
                    color: 'rgba(149,160,177, 0.1)'
                },
                {
                    channelName: 'Blogs',
                    interactionRate: 4.4,
                    heightPercentage: '44%',
                    maxWidthPercentage: '25%',
                    placeholderMode: true,
                    color: 'rgba(149,160,177, 0.1)'
                },
                {
                    channelName: 'Tiktok',
                    interactionRate: 5.1,
                    heightPercentage: '51%',
                    maxWidthPercentage: '25%',
                    placeholderMode: true,
                    color: 'rgba(149,160,177, 0.1)'
                }
            ],
            yAxisValues: [
                {
                    value: 0,
                    bottomPercentage: '0%'
                },
                {
                    value: 2,
                    bottomPercentage: '20%'
                },
                {
                    value: 4,
                    bottomPercentage: '40%'
                },
                {
                    value: 6,
                    bottomPercentage: '60%'
                },
                {
                    value: 8,
                    bottomPercentage: '80%'
                },
                {
                    value: 10,
                    bottomPercentage: '100%'
                }
            ]
        };
        this._channelInteractionRatesSubject = new Subject();
        this._selectedChannelIdSubject = new Subject();
        this._changeSubscription = combineLatest([
            this._channelInteractionRatesSubject,
            this._selectedChannelIdSubject
        ]).subscribe({
            next: function (_a) {
                var interactionRates = _a[0], selectedChannelId = _a[1];
                _this.drawData = _this.calculateDrawData(interactionRates, selectedChannelId);
            }
        });
    }
    Object.defineProperty(InteractionRateByChannelComponent.prototype, "channelInteractionRates", {
        set: function (value) {
            this._channelInteractionRatesSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InteractionRateByChannelComponent.prototype, "selectedChannelId", {
        set: function (value) {
            this._selectedChannelIdSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    InteractionRateByChannelComponent.prototype.ngOnDestroy = function () {
        this._changeSubscription.unsubscribe();
    };
    InteractionRateByChannelComponent.prototype.calculateDrawData = function (interactionRates, selectedChannelId) {
        var _this = this;
        if (!Array.isArray(interactionRates)
            || interactionRates.length === 0
            || !interactionRates.find(function (x) { return x.channelId === selectedChannelId; })) {
            this.hasNoData = true;
            return this._placeholderData;
        }
        // show maximum 4 items including selected channel
        var drawnInteractionRates = this.getDrawnChannelInteraction(interactionRates, selectedChannelId, 4);
        // calculate y axis values
        var rates = drawnInteractionRates.map(function (x) { return x.interactionRate; });
        var maxRate = Math.max.apply(Math, rates);
        var step = this.getStepByMaxRate(maxRate);
        var yAxisCount = Math.ceil(maxRate / step);
        var maxY = yAxisCount * step;
        var isZeroData = maxY === 0;
        var yAxisValues = [];
        if (isZeroData) {
            yAxisValues.push({
                value: 0,
                bottomPercentage: "0%",
            });
        }
        else {
            for (var i = 0; i <= maxY; i += step) {
                yAxisValues.push({
                    value: i,
                    bottomPercentage: i / maxY * 100 + "%",
                });
            }
        }
        var unselectedColorDelta = drawnInteractionRates[0].channelId === selectedChannelId ? 1 : 0;
        var unSelectedColors = chartConfig.unselectedColors;
        var maxWidthPercentage = 100 / drawnInteractionRates.length + "%";
        var columns = drawnInteractionRates.map(function (interactionRate, index) {
            return __assign({}, interactionRate, { heightPercentage: (isZeroData ? 0 : (interactionRate.interactionRate / maxY * 100)) + "%", maxWidthPercentage: maxWidthPercentage, tooltip: interactionRate.platformName + ": " + interactionRate.channelName, color: interactionRate.channelId === selectedChannelId
                    ? _this._selectedColor
                    : unSelectedColors[(index - unselectedColorDelta) % unSelectedColors.length] });
        });
        this.hasNoData = false;
        return { columns: columns, yAxisValues: yAxisValues };
    };
    InteractionRateByChannelComponent.prototype.getDrawnChannelInteraction = function (interactionRates, selectedChannelId, maxItemsCount) {
        var selectedChannelInteractionRate = interactionRates.find(function (x) { return x.channelId === selectedChannelId; });
        var hasSelectedChannel = !!selectedChannelInteractionRate;
        var others = interactionRates.filter(function (x) { return x !== selectedChannelInteractionRate; });
        var sorted = others.sort(function (a, b) { return b.interactionRate - a.interactionRate; });
        if (hasSelectedChannel) {
            var top3Sorted_1 = sorted.slice(0, maxItemsCount - 1);
            var top3 = interactionRates.filter(function (x) { return top3Sorted_1.indexOf(x) >= 0; });
            return [selectedChannelInteractionRate].concat(top3);
        }
        var top4Sorted = sorted.slice(0, maxItemsCount);
        return interactionRates.filter(function (x) { return top4Sorted.indexOf(x) >= 0; });
    };
    InteractionRateByChannelComponent.prototype.getStepByMaxRate = function (maxRate) {
        var availableSteps = [0.1, 0.2, 0.5, 1, 2, 5, 10, 20];
        var step = availableSteps.find(function (s) { return maxRate <= 5 * s; });
        if (step) {
            return step;
        }
        return 50;
    };
    return InteractionRateByChannelComponent;
}());
export { InteractionRateByChannelComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/interaction-rate-by-channel/interaction-rate-by-channel.component.ts.pre-build-optimizer.js